import React from 'react';

const TrendingTab = ({ trendingCategories, toggleShowcase, copyCategoryWithUrls, showcaseCatId, showcaseUrls, showcaseLoading }) => (
  <div data-testid="trending-tab">
    <h3 style={{ color: '#f59e0b', margin: '0 0 16px', fontSize: '1.1rem' }}>
      <i className="fas fa-fire" style={{ marginRight: 8 }} />
      Trending This Week
    </h3>
    {trendingCategories.length === 0 && (
      <div style={{ color: '#71717a', textAlign: 'center', padding: 40 }}>
        No trending data yet. Categories will appear here as they gain popularity.
      </div>
    )}
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 14 }}>
      {trendingCategories.map((cat, i) => (
        <div key={cat.id || i} className="ocean-shimmer shimmer-border" style={{
          background: 'linear-gradient(135deg, rgba(245,158,11,0.08), rgba(253, 230, 138,0.05))',
          borderRadius: 12, padding: 16, position: 'relative', overflow: 'hidden',
          border: `1px solid rgba(245,158,11,${i < 3 ? 0.35 : 0.15})`
        }} data-testid={`trending-cat-${i}`}>
          <div style={{ position: 'relative', zIndex: 4 }}>
            {i < 3 && (
              <span style={{
                position: 'absolute', top: -6, right: -6,
                background: i === 0 ? '#f59e0b' : i === 1 ? '#a1a1aa' : '#cd7f32',
                color: '#000', padding: '2px 8px', borderRadius: 8, fontSize: '0.6rem', fontWeight: 800
              }}>
                #{i + 1}
              </span>
            )}
            <h4 style={{ margin: '0 0 6px', color: '#334155', fontSize: '0.95rem', fontWeight: 700 }}>
              {cat.name}
            </h4>
            <div style={{ display: 'flex', gap: 10, fontSize: '0.7rem', color: '#71717a', marginBottom: 8, flexWrap: 'wrap' }}>
              {cat.protocol && <span style={{ color: '#047857' }}>{cat.protocol}</span>}
              <span style={{ color: '#f59e0b', fontWeight: 600 }}>{(cat.url_count || 0).toLocaleString()} URLs</span>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => toggleShowcase(cat.id)} className="btn-ocean"
                style={{ flex: 1, background: 'rgba(245,158,11,0.1)', border: '1px solid rgba(245,158,11,0.3)', color: '#f59e0b', padding: '6px 10px', borderRadius: 8, cursor: 'pointer', fontSize: '0.74rem', fontWeight: 600 }}>
                <i className="fas fa-eye" style={{ marginRight: 4 }} /> Preview
              </button>
              <button onClick={() => copyCategoryWithUrls(cat)} className="btn-ocean"
                style={{ flex: 1, background: 'rgba(253, 230, 138,0.12)', border: '1px solid rgba(253, 230, 138,0.3)', color: '#38bdf8', padding: '6px 10px', borderRadius: 8, cursor: 'pointer', fontSize: '0.74rem', fontWeight: 600 }}>
                <i className="fas fa-download" style={{ marginRight: 4 }} /> Copy + URLs
              </button>
            </div>
            {showcaseCatId === cat.id && (
              <div style={{ marginTop: 10, background: 'rgba(245,158,11,0.05)', borderRadius: 8, padding: 10, border: '1px solid rgba(245,158,11,0.15)', maxHeight: 250, overflowY: 'auto' }}>
                {showcaseLoading && <div style={{ color: '#71717a', fontSize: '0.72rem', textAlign: 'center', padding: 15 }}>Loading...</div>}
                {!showcaseLoading && showcaseUrls.map((u, j) => (
                  <div key={j} style={{ padding: '4px 0', borderBottom: '1px solid rgba(255, 255, 255, 0.85)', fontSize: '0.72rem' }}>
                    <a href={u.url} target="_blank" rel="noopener noreferrer" style={{ color: '#38bdf8', textDecoration: 'none', fontWeight: 600 }}>
                      {u.title || u.url}
                    </a>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default TrendingTab;
